import "./scss/main.scss"
import App from './coffee/App.coffee';

App();
